module.exports = __webpack_public_path__ + "media/images/icon/calendar-ad14eb0e6eb936045cfc8c47ff071dd2.svg";